import { createReducer } from '../../utilities';
import {
    FAIL_GET_NOTIFICATIONS_CLICKS,
    REQUEST_GET_NOTIFICATIONS_CLICKS,
    SUCCESS_GET_NOTIFICATIONS_CLICKS
} from "../../../actions/entities/notificationsCenter";

const initialState = {
    data: {},
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    return {
        ...state,
        data: action.response,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_GET_NOTIFICATIONS_CLICKS]: requestFetch,
    [SUCCESS_GET_NOTIFICATIONS_CLICKS]: successFetch,
    [FAIL_GET_NOTIFICATIONS_CLICKS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/notificationsCenter/stats.js